/* =============================================================
   CUSTOM CART DRAWER SYSTEM
   Replaces Pipeline's default drawer completely.
   Drawer ID: #custom-cart-sidebar
   ============================================================= */

console.log("Custom Cart Drawer Loaded");

/* -------------------------------------------------------------
   1) GLOBAL SELECTORS
------------------------------------------------------------- */

const CUSTOM_DRAWER = document.querySelector("#custom-cart-sidebar");
const CART_ITEMS_CONTAINER = CUSTOM_DRAWER?.querySelector("[data-custom-cart-items]");
const CART_SUBTOTAL = CUSTOM_DRAWER?.querySelector("[data-custom-cart-subtotal]");
const FREEGIFT_BLOCK = CUSTOM_DRAWER?.querySelector("[data-freegift-block]");
const FREEGIFT_STATUS = CUSTOM_DRAWER?.querySelector("[data-freegift-status]");

const FREE_GIFT_THRESHOLD = 60.00;   // adjust depending on store
const FREE_GIFT_PRODUCT_HANDLE = "free-gift-placeholder";

/* -------------------------------------------------------------
   2) OPEN / CLOSE DRAWER
------------------------------------------------------------- */

function openCustomCart() {
  if (!CUSTOM_DRAWER) return;
  CUSTOM_DRAWER.classList.add("is-open");
  document.body.classList.add("no-scroll");
}

function closeCustomCart() {
  if (!CUSTOM_DRAWER) return;
  CUSTOM_DRAWER.classList.remove("is-open");
  document.body.classList.remove("no-scroll");
}

/* Buttons that close drawer */
document.addEventListener("click", (e) => {
  if (e.target.matches("[data-custom-cart-close]")) {
    closeCustomCart();
  }
});

/* Header & mobile cart toggle */
document.addEventListener("click", (e) => {
  const toggle = e.target.closest("[data-drawer-toggle='custom-cart-sidebar']");
  if (toggle) {
    e.preventDefault();
    loadFullCart();
    openCustomCart();
  }
});

/* -------------------------------------------------------------
   3) LOAD CART (fetch Liquid-rendered snippet)
------------------------------------------------------------- */

function loadFullCart() {
  if (!CART_ITEMS_CONTAINER) return;

  CART_ITEMS_CONTAINER.innerHTML = `<div class="custom-cart-loading">Loading…</div>`;

  fetch("/cart?view=api-custom-cart")
    .then(res => res.text())
    .then(html => {
      CART_ITEMS_CONTAINER.innerHTML = html;
      updateCartTotals();
      attachLineItemListeners();
    });
}

/* -------------------------------------------------------------
   4) AJAX ADD TO CART (intercepts ALL forms)
------------------------------------------------------------- */

document.addEventListener("submit", (e) => {
  const form = e.target.closest('form[action="/cart/add"]');
  if (!form) return;

  e.preventDefault();

  const formData = new FormData(form);

  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
    headers: { "X-Requested-With": "XMLHttpRequest" }
  })
  .then(r => r.json())
  .then(() => {
    loadFullCart();
    openCustomCart();
  });
});

/* -------------------------------------------------------------
   5) UPSSELL ADD TO CART
------------------------------------------------------------- */

document.addEventListener("click", (e) => {
  const upsellBtn = e.target.closest("[data-upsell-atc]");
  if (!upsellBtn) return;

  const handle = upsellBtn.dataset.productHandle;

  fetch("/cart/add.js", {
    method: "POST",
    body: JSON.stringify({
      items: [{ id: window.all_products[handle].variants[0].id, quantity: 1 }]
    }),
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    }
  })
  .then(() => {
    loadFullCart();
    openCustomCart();
  });
});

/* -------------------------------------------------------------
   6) CART TOTALS & FREE GIFT
------------------------------------------------------------- */

function updateCartTotals() {
  fetch("/cart.js")
    .then(r => r.json())
    .then(cart => {
      const subtotal = (cart.total_price / 100).toFixed(2);

      if (CART_SUBTOTAL) {
        CART_SUBTOTAL.innerHTML = `<strong>Subtotal:</strong> $${subtotal}`;
      }

      updateFreeGift(cart);
    });
}

function updateFreeGift(cart) {
  const subtotal = cart.total_price / 100;

  if (!FREEGIFT_BLOCK || !FREEGIFT_STATUS) return;

  if (subtotal >= FREE_GIFT_THRESHOLD) {
    FREEGIFT_STATUS.textContent = "Unlocked!";
    FREEGIFT_BLOCK.classList.add("is-unlocked");

    // auto-add gift if not already in cart
    const giftInCart = cart.items.find(item => item.handle === FREE_GIFT_PRODUCT_HANDLE);

    if (!giftInCart) {
      fetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify({
          items: [{ id: window.all_products[FREE_GIFT_PRODUCT_HANDLE].variants[0].id, quantity: 1 }]
        }),
        headers: { "Content-Type": "application/json" }
      })
      .then(() => loadFullCart());
    }

  } else {
    FREEGIFT_STATUS.textContent = "Locked";
    FREEGIFT_BLOCK.classList.remove("is-unlocked");
  }
}

/* -------------------------------------------------------------
   7) QTY BUTTONS + DELETE
------------------------------------------------------------- */

function attachLineItemListeners() {
  document.querySelectorAll("[data-line-update]").forEach(btn => {
    btn.addEventListener("click", () => {
      const key = btn.dataset.key;
      const qty = parseInt(btn.dataset.qty, 10);

      fetch("/cart/change.js", {
        method: "POST",
        body: JSON.stringify({ id: key, quantity: qty }),
        headers: { "Content-Type": "application/json" }
      })
      .then(() => loadFullCart());
    });
  });

  document.querySelectorAll("[data-line-remove]").forEach(btn => {
    btn.addEventListener("click", () => {
      const key = btn.dataset.key;

      fetch("/cart/change.js", {
        method: "POST",
        body: JSON.stringify({ id: key, quantity: 0 }),
        headers: { "Content-Type": "application/json" }
      })
      .then(() => loadFullCart());
    });
  });
}

/* -------------------------------------------------------------
   8) INITIAL LOAD
------------------------------------------------------------- */

document.addEventListener("DOMContentLoaded", () => {
  loadFullCart();
});
